module.exports = __webpack_public_path__ + "static/img/star.29938e81.svg";